import { render } from "./TemplateAdminInhalt.pug?vue&type=template&id=69c85208&lang=pug"
import script from "./TemplateAdminInhalt.js?vue&type=script&lang=js"
export * from "./TemplateAdminInhalt.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__